import { render, staticRenderFns } from "./SoundSelector.vue?vue&type=template&id=da2c6496&scoped=true"
import script from "./SoundSelector.vue?vue&type=script&lang=js"
export * from "./SoundSelector.vue?vue&type=script&lang=js"
import style0 from "./SoundSelector.vue?vue&type=style&index=0&id=da2c6496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c6496",
  null
  
)

export default component.exports